import React from 'react';
import { css as reactCss, Global } from '@emotion/react';
import { colors } from '~src/main/theme/colors';

export const GlobalStyles: React.FC = () => {
  return (
    <Global
      styles={reactCss`
        body {
          width: 100vw;
          font-family: 'Inter var', 'Inter';
        }
        * {
          box-sizing: border-box;
          -webkit-tap-highlight-color: transparent;
        }

        button:focus {
          outline: none;
        }

        a {
          color: ${colors.black};
          text-decoration: underline;
        }
        a:hover {
          text-decoration: none;
        }
        a:focus {
          outline: none;
        }

        .tippy-box {
          background-color: ${colors.neutral45};
        }

        .tippy-arrow {
          color: ${colors.neutral45};
        }

        .sr-only {
          position: absolute;
          left: -10000px;
          top: auto;
          width: 1px;
          height: 1px;
          overflow: hidden;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          margin: 0;
          font-size: 1px;
          font-weight: unset;
        }

        // focus-visible styles, there exist :focus-visible pseudoselector but not supported on some browsers
        // you know which browsers we are talking about so those styles are for polyfill
        .js-focus-visible :focus:not(.focus-visible) {
          outline: none;
        }
        .focus-visible {
          outline: none;
        }
        .focus-visible.focus-visible-outline {
          outline: 2px dotted black;
        }
        .focus-visible.focus-visible-border {
          border: 2px dotted black;
        }
      `}
    />
  );
};
